import { Component, ViewChild, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import * as moment from "moment";

@Component({
    selector: 'app-ltms-datetime-picker',
    templateUrl: './ltms-datetime-picker.component.html',
    styleUrls: ['./ltms-datetime-picker.component.scss'],
    standalone: false
})
export class LtmsDatetimePickerComponent implements OnInit, OnChanges {
  @ViewChild('ltmsdatetimepicker') ltmsdatetimepicker!: ElementRef;
  private monthNames: any = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  private startOfMonth: any = moment().startOf('month');
  private endOfMonth: any = moment().endOf('month');
  private pickerType = "datetime"
  private typeList: any = ['time', 'date', 'datetime']
  private restriction: any = {}
  restricatedData: any = {}
  //  format: string = "";
  @Input() type: string = "datetime"
  @Input() props: any = {};
  @Input() elementId: string = "";
  @Input() value: string = ""
  @Input() readOnly: boolean = false
  @Output() change: any = new EventEmitter<any>();


  hours: any = _.map(Array.from(Array(24).keys()), (value: any) => {
    if (value < 10) {
      return {
        text: "0" + value,
        value: value
      };
    }
    return {
      text: "" + value,
      value: value
    };
  })
  minutes: any = _.map(Array.from(Array(60).keys()), (value: any) => {
    if (value < 10) {
      return {
        text: "0" + value,
        value: value
      };
    }
    return {
      text: "" + value,
      value: value
    };
  })
  dayShortNames: any = ['S', 'M', 'T', 'W', 'T', 'F', 'S']

  currentMonthDetail: any = {};
  monthYearList: any = [];
  isPickerOpen: boolean = false;
  isMonthYearSelectorOpen: boolean = false;
  isYearSelected: boolean = false;
  inputType: string = "datetime";
  format: string = "";
  selectedDate: any = {
    date: moment().date(),
    year: moment().year(),
    month: moment().month(),
    timestamp: moment().valueOf(),
    enabled: true
  }

  selectedTime: any = {
    "hour": 0,
    "minute": 0
  }

  selectedYearMonth: any = {
    year: moment().year(),
    month: moment().month(),
    monthName: this.monthNames[moment().month()]
  }
  placeholder: string = "Click Here";

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeProps(this.props);
    this.initData()
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      if (this.ltmsdatetimepicker && this.ltmsdatetimepicker.nativeElement !== event.target && !this.ltmsdatetimepicker.nativeElement.contains(event.target)) {
        this.isPickerOpen = false
      }
    });
  }

  initializeProps(props?: any) {
    if (props && !_.isEmpty(props)) {
      if (typeof props == "string") {
        this.props = JSON.parse(props)
      }
      if (this.props.restriction && !_.isEmpty(this.props.restriction)) {
        // this.restriction = this.props.restriction;
      }

      if (_.hasIn(this.props, 'type') && this.typeList.indexOf(this.props.type) >= 0) {
        this.pickerType = this.props.type
      }
      if (this.type && this.typeList.indexOf(this.type) >= 0) {
        this.pickerType = this.type
      }
      if (_.hasIn(this.props, 'format') && this.props.fromat != "") {
        this.format = _.get(props, 'format', '')
      }
      if (this.props.placeholder) {
        this.placeholder = props.placeholder
      }
    }
    this.initRestricatedData()
  }
  initRestricatedData() {
    if (this.restriction.from && moment(this.restriction.from).isValid()) {
      this.restricatedData['from'] = {
        date: moment(this.restriction.from).date(),
        year: moment(this.restriction.from).year(),
        month: moment(this.restriction.from).month(),
      }
    }
    if (this.restriction.to && moment(this.restriction.to).isValid()) {
      this.restricatedData['to'] = {
        date: moment(this.restriction.to).date(),
        year: moment(this.restriction.to).year(),
        month: moment(this.restriction.to).month(),
      }
    }
  }

  private initData() {
   
    if (this.value != "" && moment(this.value).isValid()) {
      this.startOfMonth = moment(this.value).startOf('month');
      this.endOfMonth = moment(this.value).endOf('month');
      this.selectedDate = {
        date: moment(this.value).date(),
        year: moment(this.value).year(),
        month: moment(this.value).month(),
        timestamp: moment(this.value).valueOf(),
        enabled: true
      }
      this.selectedTime = {
        "hour": moment(this.value).hour(),
        "minute": moment(this.value).minute()
      }
      this.value = this.formateDate(this.value);
    }
    
    this.currentMonthDetail = this.getMonthDetails(this.startOfMonth, this.endOfMonth)
  }

  getMonthAndYearList(event:any,startYear?: any, endYear?: any) {
    event.stopPropagation();
    this.isMonthYearSelectorOpen = true;
    this.monthYearList = [];
    const start = (startYear) ? startYear : new Date().getFullYear() - 7;
    const end = (endYear) ? endYear : new Date().getFullYear() + 7;
    for (let year = start; year <= end; year++) {
      this.monthYearList.push({
        name:year,
        disabled:this.isMonthYearDisabled(year,'year')
      })
    }
  }

  changeYearList(event:any,isNext: boolean) {
    event.stopPropagation();
    if (isNext) {
      const lastYear = this.monthYearList[this.monthYearList.length - 1].name;
      const start = lastYear + 1
      this.getMonthAndYearList(event,lastYear + 1, lastYear + 14)
    } else {
      const firstYear = this.monthYearList[0].name;
      this.getMonthAndYearList(event,firstYear - 14, firstYear - 1)
    }
  }

  selectMonthAndYear(event:any,data: any, index: number) {
    event.stopPropagation();
    if(!data.disabled){
      if (this.isYearSelected) {
        this.selectedYearMonth.month = index;
        this.selectedYearMonth.monthName = this.monthNames[index];
        this.isYearSelected = false;
        const date = moment().set("year", this.selectedYearMonth.year).set('month', this.selectedYearMonth.month);
        this.startOfMonth = moment(date).startOf('month');
        this.endOfMonth = moment(date).endOf('month');
        this.currentMonthDetail = this.getMonthDetails(this.startOfMonth, this.endOfMonth)
        this.isMonthYearSelectorOpen = false;
      } else {
        this.selectedYearMonth.year = data.name;
        this.isYearSelected = true;
        this.monthYearList = _.map(this.monthNames,(name:string,index:number)=>{
          return {
            name:name,
            disabled:this.isMonthYearDisabled(index,'month')
          }
        });
      }
    }
  }

  closeMonthYearSelector(event:any) {
    event.stopPropagation();
    this.isYearSelected = false;
    this.isMonthYearSelectorOpen = false;
  }

  toggleDatePicker(event:any) {
    event.preventDefault()
    if (this.isPickerOpen) {
      this.isPickerOpen = false;
    } else {
      this.isPickerOpen = true;
      this.setScrollForTime()
    }

  }

  closeDatePicker() {
    this.isPickerOpen = false;
  }


  private setScrollForTime() {
    setTimeout(() => {
      const hourSelector: any = document.getElementById('hours-selector');
      const minuteSelector: any = document.getElementById('minutes-selector');
      const hourId = (this.selectedTime.hour < 10) ? "0" + this.selectedTime.hour : "" + this.selectedTime.hour;
      const minuteId = (this.selectedTime.minute < 10) ? "0" + this.selectedTime.minute : "" + this.selectedTime.minute;
      const hourEl: any = document.getElementById(hourId)
      const minuteEl: any = document.getElementById(minuteId)

      hourSelector.scrollTo(0, hourEl.offsetTop - 20);
      minuteSelector.scrollTo(0, minuteEl.offsetTop - 20)
    }, 500);

  }

  changeDatesRange(event:any,isNext: boolean) {
    event.stopPropagation();
    if (isNext) {
      this.startOfMonth = moment(this.startOfMonth).add(1, 'month').startOf('day');
    } else {
      this.startOfMonth = moment(this.startOfMonth).subtract(1, 'month').startOf('day');
    }
    this.endOfMonth = moment(this.startOfMonth).endOf('month').startOf('day');
    this.currentMonthDetail = this.getMonthDetails(this.startOfMonth, this.endOfMonth)
  }

  selectDate(day: any) {
    if (!day.disabled) {
      this.selectedDate = day;
    }
  }

  setTime(type: string, value: any) {
    this.selectedTime[type] = value
  }

  applyDateTime() {
    let date: any;
    if (this.pickerType == "datetime") {
      date = new Date(this.selectedDate.year, this.selectedDate.month, this.selectedDate.date, this.selectedTime.hour, this.selectedTime.minute, 0, 0);
    } else if (this.pickerType == 'date') {
      date = new Date(this.selectedDate.year, this.selectedDate.month, this.selectedDate.date, 0, 0, 0, 0);
    } else if (this.pickerType == "time") {
      date = new Date(0, 0, 0, this.selectedTime.hour, this.selectedTime.minute, 0, 0);
    }

    if (date && date != "") {
      // this.value = date
      this.value = this.formateDate(date);
      this.change.emit({
        date: moment(date),
        foramtedDate: (this.props.fromat) ? moment(date).format(this.props.fromat) : moment(date).toISOString()
      });
      this.isPickerOpen = false;
    } else {
      this.value = this.formateDate(moment());
    }
  }

  formateDate(date: any) {
    let formatedDate: string = ""
    if (this.pickerType == 'date') {
      formatedDate = moment(date).format('DD-MM-YYYY')
    } else if (this.pickerType == 'time') {
      formatedDate = moment(date).format('HH:mm')
    } else {
      formatedDate = moment(date).format('DD-MM-YYYY HH:mm')
    }
    return formatedDate;
  }

  resetDateTime() {
    this.selectedDate = {
      date: moment().date(),
      year: moment().year(),
      month: moment().month(),
      timestamp: moment().valueOf(),
      enabled: true
    }
    this.selectedTime = {
      "hour": 0,
      "minute": 0
    }
    this.startOfMonth = moment().startOf('month');
    this.endOfMonth = moment().endOf('month');
    this.currentMonthDetail = this.getMonthDetails(this.startOfMonth, this.endOfMonth)

    this.setScrollForTime()
  }

  /**
  * Description: function used to calculate the date range for a single month to view in date picker calendar.its return a month object
  * @param startDate 
  * @param endDate 
  * @returns objet of month
  */
  private getMonthDetails(startDate: any, endDate: any) {
    let daysList: any = [];
    let flag = true;
    const firstDay = startDate.date;
    const lastDayOfMonth = endDate.get('date');

    // create date range for active monthes like 1 to 30 its depend on end date of month
    var days: any = [...Array(lastDayOfMonth).keys()].map((day) => {
      const dateObject = moment(startDate).add(day, 'days');
      return {
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: this.isDateDisabled(dateObject),
        enabled: true
      }
    })
    // add previous month date on if start date is not equal to start date of week
    if (startDate.day() != 0) {
      days = this.addPriviousMonthDate(startDate, firstDay, days);
    }

    days = this.addNextMonthDate(startDate, days);
    // grouping the days by weeks
    while (flag) {
      daysList.push(days.splice(0, 7));
      if (days.length <= 0) {
        flag = false;
      }
    }
    return {
      days: daysList,
      year: startDate.year(),
      month: startDate.month(),
      monthName: this.monthNames[startDate.month()],
      currentDate: new Date().getDate()
    };
  }

  // Helper Function for getMonthDetails it will used for complete the first week days
  private addPriviousMonthDate(date: any, firstDay: number, days: any) {
    // get start date of previous week.
    const startOfWeek = moment(date).subtract(1, 'month').endOf('month').startOf('week');
    const startDate: number = startOfWeek.get('date');
    const endDate: number = moment(date).subtract(1, 'month').endOf('month').get('date');
    // push previos month date in days array of active month to complete the first week
    for (var i = startDate; i <= endDate; i++) {
      const dateObject = moment(startOfWeek).date(i);
      days.splice(0, 0, {
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: this.isDateDisabled(dateObject),
        enabled: false
      });
    }
    return days;
  }

  // Helper Function for getMonthDetails it will used for complete the end week days
  private addNextMonthDate(date: any, days: any) {
    let firstDay = moment(date).add(1, 'month').startOf('month');
    // push first day of next month in days array for active month till total days reached to 42
    days.push({
      date: firstDay.date(),
      year: firstDay.year(),
      month: firstDay.month(),
      timestamp: firstDay.valueOf(),
      disabled: this.isDateDisabled(firstDay),
      enabled: false
    });
    // push next month dates  in days array for active month till total days reached to 42
    for (var day = days.length; day < 42; day++) {
      const dateObject = moment(firstDay).add(1, 'day');
      days.push({
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: this.isDateDisabled(dateObject),
        enabled: false
      });
    }
    return days;
  }

  private isDateDisabled(dateObject: any) {
    const isBefore = (_.hasIn(this.restriction, 'from') && moment(this.restriction.from).isValid()) ? moment(dateObject).isBefore(moment(this.restriction.from), 'day') : false;
    const isAfter = (_.hasIn(this.restriction, 'to') && moment(this.restriction.to).isValid()) ? moment(dateObject).isAfter(moment(this.restriction.to), 'day') : false;
    return (isBefore || isAfter)?true:false;
  }
  isMonthYearDisabled(value:any,type:string){
    let isAfter:boolean=false;
    let isBefore:boolean= false;
    if(type == 'month'){
      if((_.hasIn(this.restricatedData , 'to.year') && this.restricatedData.to.year <= this.selectedYearMonth.year) ){
        isAfter = (_.hasIn(this.restricatedData , 'to.month') && this.restricatedData.to.month < value)?true:false;
      }
      if((_.hasIn(this.restricatedData , 'from.year') && this.restricatedData.from.year >= this.selectedYearMonth.year)){
        isBefore = (_.hasIn(this.restricatedData , 'from.month') && this.restricatedData.from.month > value)?true:false;
      }
    }
    if(type == "year"){
      isAfter = (_.hasIn(this.restricatedData , 'to.year') && this.restricatedData.to.year < value)?true:false;
      isBefore = (_.hasIn(this.restricatedData , 'from.year') && this.restricatedData.from.year > value)?true:false;
    }
    return (isAfter || isBefore)?true :false
  }

  isButtonActive(selectorType: string, buttonType: string,data?:any) {
    if (selectorType == 'calendar') {
      if (buttonType == 'next') {
        if (!_.hasIn(this.restricatedData, 'to.month') || (_.hasIn(this.restricatedData, 'to.month') && this.restricatedData.to.month > this.currentMonthDetail.month)) {
          return true
        } else {
          return false;
        }
      } else if (buttonType == 'previous') {
        if (!_.hasIn(this.restricatedData, 'from.month') || (_.hasIn(this.restricatedData, 'from.month') && this.restricatedData.from.month < this.currentMonthDetail.month)) {
          return true
        } else {
          return false;
        }
      } else {
        return true
      }
    } else if (selectorType == 'yearmonth') {
      if (buttonType == 'next') {
        if (!_.hasIn(this.restricatedData, 'to.year') || (_.hasIn(this.restricatedData, 'to.year') && this.restricatedData.to.year > data.name)) {
          return true
        } else {
          return false;
        }
      } else if (buttonType == 'previous') {
        if (!_.hasIn(this.restricatedData, 'from.year') || (_.hasIn(this.restricatedData, 'from.year') && this.restricatedData.from.year < data.name)) {
          return true
        } else {
          return false;
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }

}
